import React from 'react';

interface ModalProps {
  message: string | React.ReactNode;
  onConfirm: () => void;
  onCancel: () => void;
  isClosing?: boolean;
}

const Modal: React.FC<ModalProps> = ({ message, onConfirm, onCancel, isClosing }) => {
  return (
    <div className={`modal-backdrop ${isClosing ? 'closing' : ''}`} onClick={onCancel}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-text">{message}</div>
        <div className="modal-actions">
          <button className="btn btn-secondary" onClick={onCancel} style={{ flex: 1 }}>Abbrechen</button>
          <button className="btn btn-danger" onClick={onConfirm} style={{ flex: 1 }}>Löschen</button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
